// import React, { useEffect, useRef, useState } from 'react';
// import AudioPlayer from './AudioPlayer';

// const AudioBottomSheet = ({ audioVisible, onClose, audioProps }) => {
//     const playerRef = useRef(null);
//     const [resetKey, setResetKey] = useState(0);
//     const [isMounted, setIsMounted] = useState(false);

//     // Handle mount/unmount based on audioVisible
//     useEffect(() => {
//         if (audioVisible) {
//             setIsMounted(true);
//             setResetKey(prev => prev + 1);
//         } else {
//             playerRef.current?.stopAudioExternally?.();
//         }
//     }, [audioVisible]);

//     // Handle Escape key
//     useEffect(() => {
//         const handleKeyDown = (e) => {
//             if (e.key === 'Escape' && audioVisible) {
//                 onClose?.();
//             }
//         };

//         window.addEventListener('keydown', handleKeyDown);
//         return () => window.removeEventListener('keydown', handleKeyDown);
//     }, [audioVisible]);

//     // Handle animation end for unmounting
//     const handleAnimationEnd = () => {
//         if (!audioVisible) {
//             setIsMounted(false);
//         }
//     };

//     if (!isMounted) return null;

//     return (
//         <div className="fixed inset-0 z-50 overflow-hidden">
//             {/* Overlay */}
//             <div
//                 className={`absolute inset-0 bg-black transition-opacity duration-300 ${
//                     audioVisible ? 'opacity-50' : 'opacity-0'
//                 }`}
//                 onClick={onClose}
//             />

//             {/* Sheet content */}
//             <div
//                 className={`absolute bottom-0 left-0 right-0 bg-white rounded-t-2xl shadow-xl transition-transform duration-300 ${
//                     audioVisible ? 'translate-y-0' : 'translate-y-full'
//                 }`}
//                 style={{ height: '35vh' }}
//                 onTransitionEnd={handleAnimationEnd}
//             >
//                 <div className="h-full p-4">
//                     <AudioPlayer
//                         key={resetKey}
//                         ref={playerRef}
//                         {...audioProps}
//                         onAudioEnd={onClose}
//                     />
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default AudioBottomSheet;

import React, { useEffect, useRef, useState } from "react";
import AudioPlayer from "./AudioPlayer";
import AppInstallPromo from "./AppInstallPromo";


const AudioBottomSheet = ({ audioVisible, onClose, audioProps }) => {
  const playerRef = useRef(null);
  const [resetKey, setResetKey] = useState(0);
  const [isMounted, setIsMounted] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);
  const [showAppPromo, setShowAppPromo] = useState(true);

  // Check for desktop viewport
  useEffect(() => {
    const checkIfDesktop = () => {
      setIsDesktop(window.innerWidth >= 768); // Adjust breakpoint as needed
    };

    checkIfDesktop();
    window.addEventListener("resize", checkIfDesktop);
    return () => window.removeEventListener("resize", checkIfDesktop);
  }, []);

  // Handle mount/unmount based on audioVisible
  useEffect(() => {
    if (audioVisible) {
      setIsMounted(true);
      setResetKey((prev) => prev + 1);
    } else {
      playerRef.current?.stopAudioExternally?.();
    }
  }, [audioVisible]);

  // Handle Escape key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape" && audioVisible) {
        onClose?.();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [audioVisible]);

  // Handle animation end for unmounting
  const handleAnimationEnd = () => {
    if (!audioVisible) {
      setIsMounted(false);
    }
  };
  const handleAudioPlay = () => {
    setShowAppPromo(true);
  };

  if (!isMounted) return null;

  return (
    
    <div className="fixed inset-0 z-50 overflow-hidden">
      {/* Overlay with different opacity for desktop */}
      <div
        className={`absolute inset-0 bg-black transition-opacity duration-300 ${
          audioVisible ? (isDesktop ? "opacity-70" : "opacity-50") : "opacity-0"
        }`}
        onClick={onClose}
      />

      {/* Sheet content - different positioning/sizing for desktop */}
      <div
        className={`absolute rounded-t-2xl shadow-xl transition-all duration-300 ${
          audioVisible
            ? isDesktop
              ? "translate-y-0 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-auto max-h-[80vh]"
              : "translate-y-0 bottom-0 left-0 right-0 h-[35vh]"
            : isDesktop
            ? "translate-y-4 opacity-0 top-1/2 left-1/2 transform -translate-x-1/2"
            : "translate-y-full bottom-0 left-0 right-0"
        }`}
        onTransitionEnd={handleAnimationEnd}
      >
        {/* Close button for desktop */}
        {isDesktop && (
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 z-10"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        )}

        <div className={`${isDesktop ? "p-6" : "p-4"} h-full`}>
          <AudioPlayer
            key={resetKey}
            ref={playerRef}
            {...audioProps}
            onAudioEnd={onClose}
            isDesktop={isDesktop} // Pass desktop flag to AudioPlayer if needed
          />
        
        </div>
      </div>
    </div>
   
  );
};

export default AudioBottomSheet;
